import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-faultconfirmation-faultreport',
  templateUrl: './faultconfirmation.component.html',
  styleUrls: ['./faultconfirmation.component.sass']
})
export class FaultconfirmationComponent implements OnInit {
  @Input() index;
  @Input() respuesta;
  @Input() screenView;
  @Output() updateScreenView = new EventEmitter<any>();  
  @Output() screenView2 = new EventEmitter<any>();  
  constructor() { }

  ngOnInit() {
  }

  close(index:number){
    this.screenView[index] = 1;
    this.screenView2.emit(this.screenView);
  }
}